import dayjs from 'dayjs';

export const getFormattedDate = (
  date: string,
  sourceFormat?: string,
  targetFormat?: string,
): string => {
  // eslint-disable-next-line custom/no-restricted-dayjs

  return dayjs(date, sourceFormat || 'DD/MM/YYYY').format(
    targetFormat || 'D MMM YYYY',
  );
};
